var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidanceandguideline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 40,
    height: 40,
    transform: "translate(273 208)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_8",
    "data-name": "Mask Group 8",
    transform: "translate(-273 -208)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(280.989 216.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M18.8,16.205a.7.7,0,0,1,0,.99l-3.5,3.5a.7.7,0,0,1-.884.088l-2.1-1.4a.7.7,0,1,1,.777-1.165L14.712,19.3l3.1-3.1A.7.7,0,0,1,18.8,16.205Z",
    transform: "translate(-2.697 -4.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M6.5,0A3.584,3.584,0,0,0,3,3.662V21.237a2.15,2.15,0,0,0,2.1,2.2H19.107a2.15,2.15,0,0,0,2.1-2.2V6.591a.717.717,0,0,0-.7-.732H6.5a2.151,2.151,0,0,1-2.1-2.2,2.151,2.151,0,0,1,2.1-2.2H20.507a.717.717,0,0,0,.7-.732.717.717,0,0,0-.7-.732ZM4.4,6.591V21.237a.717.717,0,0,0,.7.732H19.107a.717.717,0,0,0,.7-.732V7.323H6.5A3.387,3.387,0,0,1,4.4,6.591Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M13.7,4a.7.7,0,1,0,0,1.4h9.8a.7.7,0,1,0,0-1.4Z",
    transform: "translate(-2.997 -1.199)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidanceandguideline);
export default __webpack_public_path__ + "static/media/guidanceandguideline.4436aa36fb2e51f08163923c36c7c283.svg";
export { ForwardRef as ReactComponent };